export default __webpack_public_path__ + "static/media/contactless-card.6a2ee219.svg";